import { IssueLiabilityResponsibleType } from '@gooduncles/gu-app-schema';
import { Input, Select } from 'antd';
import { FC } from 'react';

import { selectValidPartnersUsers } from 'src/redux/slices/partners';
import { useAppSelector } from 'src/redux/store';

import useSWRProductSuppliers from 'src/hooks/swr/useSWRProductSuppliers';
import useSWRStores from 'src/hooks/swr/useSWRStores';
import useSWRUsers from 'src/hooks/swr/useSWRUsers';
import { formatDisplayName } from 'src/hooks/subscription/useStaffUsers';

import { selectCommonProps } from './liabilityTypes';

interface ResponsibleIdSelectorProps {
  responsibleType?: IssueLiabilityResponsibleType;
  value?: string | null;
  onChange?: (value: string | null) => void;
}

/**
 * 책임자 유형에 따른 동적 책임자 Select 컴포넌트
 */
const ResponsibleIdSelector: FC<ResponsibleIdSelectorProps> = ({ responsibleType, value, onChange }) => {
  const { stores } = useSWRStores([['state', '!=', 'closed']]);
  const { users } = useSWRUsers([['role', 'in', ['manager', 'admin']]]);
  const partnersUsers = useAppSelector(selectValidPartnersUsers);
  const { productSuppliers } = useSWRProductSuppliers([['deletedAt', '==', null]]);

  const handleChange = (newValue: string) => {
    onChange?.(newValue || null);
  };

  switch (responsibleType) {
    case 'store':
      return (
        <Select
          {...selectCommonProps}
          placeholder='매장 선택'
          options={(stores ?? []).map((store) => ({
            value: store._id,
            label: store.storeNickname ?? store.storeName,
          }))}
          value={value}
          onChange={handleChange}
        />
      );
    case 'operator':
      return (
        <Select
          {...selectCommonProps}
          placeholder='관리자 선택'
          options={(users ?? []).map((user) => ({
            value: user._id,
            label: formatDisplayName(user),
          }))}
          value={value}
          onChange={handleChange}
        />
      );
    case 'partners':
      return (
        <Select
          {...selectCommonProps}
          placeholder='파트너 선택'
          options={(partnersUsers ?? []).map((partner) => ({
            value: partner._id,
            label: partner.nickname,
          }))}
          value={value}
          onChange={handleChange}
        />
      );
    case 'productSupplier':
      return (
        <Select
          {...selectCommonProps}
          placeholder='거래처 선택'
          options={(productSuppliers ?? []).map((supplier) => ({
            value: supplier._id,
            label: supplier.name,
          }))}
          value={value}
          onChange={handleChange}
        />
      );
    case 'etc':
    default:
      return (
        <Input
          placeholder='기타 책임자'
          style={{ width: 200 }}
          value={value ?? ''}
          onChange={(e) => onChange?.(e.target.value || null)}
        />
      );
  }
};

export default ResponsibleIdSelector;
